<template>
  <span :class="circle_classes">
    <FontAwesomeIcon
      v-if="icon"
      :icon="icon"
    />
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { STATUS, STATUS_COLORS } from '@/app/data/status_constants';
import { SIZE_CLASSES_CIRCLE as SIZE_CLASSES } from '@/app/shared_components/tags/tag_constants';

const props = defineProps({
  color: {
    type: String,
    default: STATUS.DEFAULT,
    validator: (value) => Object.values(STATUS).includes(value),
  },
  icon: { type: [Array, String], default: null },
  size: {
    type: String,
    default: 'small',
    validator: (value) => Object.keys(SIZE_CLASSES).includes(value),
  },
});

const circle_classes = computed(() => {
  const theme = STATUS_COLORS[props.color];
  return [
    'inline-flex items-center justify-center rounded-full',
    theme.TAG_BG,
    theme.TAG_TEXT,
    SIZE_CLASSES[props.size],
  ];
});
</script>
